import React, { useState, useMemo } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../src/components/Card.js";
import Swal from "sweetalert2"
import RegistrasiService from "../../services/registrasi/RegistrasiService.js";

function autoFormatNPWP(NPWPString) {
    try {
        var cleaned = ("" + NPWPString).replace(/\D/g, "");
        var match = cleaned.match(
            /(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,1})?(\d{0,3})?(\d{0,3})?$/
        );
        return [
            match[1],
            match[2] ? "." : "",
            match[2],
            match[3] ? "." : "",
            match[3],
            match[4] ? "." : "",
            match[4],
            match[5] ? "-" : "",
            match[5],
            match[6] ? "." : "",
            match[6],
        ].join("");
    } catch (err) {
        return "";
    }
}

const isValidNPWP = (val) => {
    return /^\d{3}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/.test(val);
};

const FormRegistrasiTrader = () => {

    let RegService = useMemo(() => new RegistrasiService(), []);

    // State for NPWP
    const [npwpError, setNpwpError] = useState(null);
    const [showNpwpHint, setShowNpwpHint] = useState(false);

    const handleNPWPChange = (e) => {
        const formatted = autoFormatNPWP(e.target.value);
        setNpwp(formatted);
    };

    // State for other form fields
    const [namaTrader, setNamaTrader] = useState("");
    const [npwp, setNpwp] = useState("");
    const [emailTrader, setEmailTrader] = useState("");
    const [alamatTrader, setAlamatTrader] = useState("");
    const [noIzin, setNoIzin] = useState("");

    const [username, setUsername] = useState("");
    const [namaUser, setNamaUser] = useState("");
    const [noIdUser, setNoIdUser] = useState("");
    const [emailUser, setEmailUser] = useState("");
    const [alamatUser, setAlamatUser] = useState("");
    const [role] = useState("4");

    // State for form submission
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);

        try {
            const payload = {
                namaTrader,
                npwp,
                emailTrader,
                alamatTrader,
                noIzin,
                username,
                namaUser,
                role: "4", // misalnya role trader
                noIdUser,
                emailUser,
                alamatUser
            };

            const response = await RegService.registerTrader(payload);

            Swal.fire({
                icon: "success",
                title: "Registrasi Berhasil",
                text: response.data.message,
            });

            // Reset form / arahkan ke halaman lain
        } catch (error) {
            console.error(error);
            const msg =
                error.response?.data?.message || "Registrasi gagal, silakan coba lagi.";

            Swal.fire({
                icon: "error",
                title: "Gagal",
                text: msg,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>
                    <h4 className="card-title mb-2">FORM REGISTRASI</h4>
                    <ul>
                        <li>Harap isi data dengan benar sesuai dokumen resmi Anda.</li>
                        <li>Data dengan tanda bintang (*) harus diisi.</li>
                        <li>
                            File upload: .pdf, .png, .jpg, .jpeg, max. 1 Mb.
                        </li>
                    </ul>
                </Card.Header.Title>
            </Card.Header>

            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={12}>
                            {/* NPWP */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>NPWP Perusahaan*</Form.Label>
                                <Col md={5}>
                                    <div className="d-inline-block">
                                        <Form.Control
                                            type="text"
                                            placeholder="NPWP 16 Digit"
                                            maxLength={21}
                                            value={npwp}
                                            onChange={handleNPWPChange}
                                            onFocus={() => setShowNpwpHint(true)}
                                            onBlur={() => {
                                                setShowNpwpHint(false);
                                                if (!isValidNPWP(npwp)) {
                                                    setNpwpError("Format NPWP tidak valid (contoh: 012.345.678.9-012.345)");
                                                } else {
                                                    setNpwpError(null);
                                                }
                                            }}
                                            isInvalid={!!npwpError}
                                        />
                                        <Form.Control.Feedback type="invalid">{npwpError}</Form.Control.Feedback>
                                        {showNpwpHint && (
                                            <Form.Text className="text-muted">
                                                Jika dalam dokumen masih 15 Digit, tambahkan angka 0 di awal nomor NPWP.
                                            </Form.Text>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}><Form.Control type="file" /></Col>
                            </Form.Group>

                            {/* Nama Perusahaan */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Nama Perusahaan*</Form.Label>
                                <Col md={9}><Form.Control type="text" value={namaTrader} onChange={(e) => setNamaTrader(e.target.value)} placeholder="Nama Perusahaan" /></Col>
                            </Form.Group>

                            {/* Nama User */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Nama User*</Form.Label>
                                <Col md={9}><Form.Control type="text" value={namaUser} onChange={(e) => setNamaUser(e.target.value)} placeholder="Nama User" /></Col>
                            </Form.Group>

                            {/* Jabatan */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Jabatan*</Form.Label>
                                <Col md={9}><Form.Control type="text" value={namaUser} onChange={(e) => setNamaUser(e.target.value)} placeholder="Jabatan" /></Col>
                            </Form.Group>

                            {/* Identitas */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Jenis Identitas*</Form.Label>
                                <Col md={3}><Form.Select className="w-100"><option>KTP</option><option>SIM</option><option>Paspor</option></Form.Select></Col>
                                <Form.Label column md={2}>Nomor Identitas*</Form.Label>
                                <Col md={2}><Form.Control type="text" placeholder="Nomor Identitas" /></Col>
                                <Col md={2}><Form.Control type="file" /></Col>
                            </Form.Group>

                            {/* Nomor Izin */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Nomor Izin Usaha*</Form.Label>
                                <Col md={6}><Form.Control type="text" placeholder="Nomor Izin Usaha" /></Col>
                                <Col md={3}><Form.Control type="file" /></Col>
                            </Form.Group>

                            {/* Alamat Rumah */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Alamat Rumah</Form.Label>
                                <Col md={9}><Form.Control as="textarea" rows={2} /></Col>
                            </Form.Group>

                            {/* Email & HP */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Email Pengguna</Form.Label>
                                <Col md={4}><Form.Control type="email" /></Col>
                                <Form.Label column md={2}>No HP</Form.Label>
                                <Col md={3}><Form.Control type="text" /></Col>
                            </Form.Group>

                            {/* Alamat Kantor */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Alamat Kantor</Form.Label>
                                <Col md={9}><Form.Control as="textarea" rows={2} /></Col>
                            </Form.Group>

                            {/* Provinsi & Kab/Kota */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Provinsi</Form.Label>
                                <Col md={4}><Form.Select><option>Pilih Provinsi</option></Form.Select></Col>
                                <Form.Label column md={2}>Kab/Kota</Form.Label>
                                <Col md={3}><Form.Select><option>Pilih Kabupaten/Kota</option></Form.Select></Col>
                            </Form.Group>

                            {/* Kode Pos & Telepon */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Kode Pos*</Form.Label>
                                <Col md={3}><Form.Control type="text" /></Col>
                                <Form.Label column md={3}>Telp Kantor</Form.Label>
                                <Col md={3}><Form.Control type="text" /></Col>
                            </Form.Group>

                            {/* Email Kantor */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Email Kantor*</Form.Label>
                                <Col md={9}><Form.Control type="email" /></Col>
                            </Form.Group>

                            {/* Keterangan */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Keterangan</Form.Label>
                                <Col md={9}><Form.Control as="textarea" rows={2} /></Col>
                            </Form.Group>

                            {/* UPT */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>UPT</Form.Label>
                                <Col md={9}><Form.Control type="text" disabled /></Col>
                            </Form.Group>

                            {/* Username */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>User Name</Form.Label>
                                <Col md={9}><Form.Control type="text" /></Col>
                            </Form.Group>

                            {/* Security Code */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column md={3}>Security Code</Form.Label>
                                <Col md={5}><Form.Control type="text" /></Col>
                                <Col md={4}><Button variant="warning">Refresh</Button></Col>
                            </Form.Group>

                            {/* Checkbox */}
                            <Form.Group className="mb-3">
                                <Form.Check type="checkbox" label="Setuju dengan syarat dan ketentuan" />
                            </Form.Group>

                            {/* Buttons */}
                            <div className="d-flex justify-content-center">
                                <Button variant="primary" className="me-2">Submit</Button>
                                <Button variant="danger">Cancel</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default FormRegistrasiTrader;
